export default __webpack_public_path__ + "resources/icons/d211-3fd3.webp";